import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const valueBullets = [{
  emoji: '📄',
  text: '100% digital (PDF + planificador imprimible)'
}, {
  emoji: '⚡',
  text: 'Acceso en 5 min'
}, {
  emoji: '👶',
  text: 'Para hijos de 3 a 12 años'
}, {
  emoji: '⏱️',
  text: 'Actividades de 5, 15 y 30 minutos'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream-100" data-id="element-91" data-mp="129h0vnss70df">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-terracotta-100/70 blur-2xl" data-id="element-92" data-mp="128pft6wt8l1e" />
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-1/2 h-80 w-80 rounded-full bg-sage-100/80 blur-3xl" data-id="element-93" data-mp="saruosa8z4d0" />

      <div className="relative mx-auto max-w-3xl px-5 pb-16 pt-12 sm:px-8 sm:pb-24 sm:pt-16" data-id="element-94" data-mp="nbooh4ij6s3g">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center" data-id="element-95" data-mp="3d2bmnxfzddz8">
          <span className="inline-flex items-center gap-2 rounded-full border border-bark-800/10 bg-cream-50 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-bark-600 shadow-sm" data-id="element-96" data-mp="3j6obhix6kkpk">
            👨‍👩‍👧 LIBROFY.STORE™
          </span>

          <h1 className="mt-7 font-display text-4xl font-semibold leading-[1.08] tracking-tight text-bark-900 sm:text-5xl md:text-6xl" data-id="element-97" data-mp="3e8efj63mtg2w">
            Todo tu sistema de conexión familiar.
            <span className="mt-2 block text-terracotta-500" data-id="element-98" data-mp="3599ent4llank">Listo. Desde hoy.</span>
          </h1>

          <p className="mt-6 font-display text-lg font-medium text-bark-600 sm:text-xl" data-id="element-99" data-mp="2qkmrx6cn5gmb">
            KIT PADRES PRESENTES 
          </p>

          <div aria-hidden="true" className="mx-auto mt-7 flex items-end justify-center gap-2" data-id="element-100" data-mp="2vjg9payyntsa">
            <span className="h-10 w-7 rounded-md rounded-l-sm bg-terracotta-500/85 sm:h-12 sm:w-8" data-id="element-101" data-mp="2hjoxnfs08ngx" />
            <span className="h-14 w-8 rounded-md rounded-l-sm bg-sage-500/85 sm:h-16 sm:w-9" data-id="element-102" data-mp="2lk8qw89gj6xs" />
            <span className="h-[4.5rem] w-9 rounded-md rounded-l-sm bg-bark-800/85 sm:h-20 sm:w-10" data-id="element-103" data-mp="s3mahuslbkuo" />
            <span className="h-14 w-8 rounded-md rounded-l-sm bg-honey-500/80 sm:h-16 sm:w-9" data-id="element-104" data-mp="n9qeuyzsua2o" />
            <span className="h-10 w-7 rounded-md rounded-l-sm bg-terracotta-300/85 sm:h-12 sm:w-8" data-id="element-105" data-mp="icrngo7ish86" />
          </div>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-bark-600 sm:text-lg" data-id="element-106" data-mp="db2d7as4g7l5">
            El sistema N°1 para padres y madres que trabajan mucho y no quieren perderse la infancia
            de sus hijos
          </p>

          <p className="mx-auto mt-5 max-w-2xl rounded-3xl bg-cream-50/80 px-5 py-4 text-sm leading-relaxed text-bark-600 shadow-sm sm:text-base" data-id="element-107" data-mp="1126nqgfdt2bi">
            Rutinas + guiones + planificador listos para usar. Sin improvisar. Sin culpa. Sin perder
            más domingos pensando <span className="italic" data-id="element-108" data-mp="3lqm4435bldx1">“debería estar más presente”</span>.
          </p>
        </motion.div>

        <motion.ul initial="hidden" animate="visible" variants={{
        visible: {
          transition: {
            staggerChildren: 0.08,
            delayChildren: 0.25
          }
        }
      }} className="mx-auto mt-9 grid max-w-xl gap-3 sm:grid-cols-2" data-id="element-109" data-mp="1x9b5n20k33d3">
          {valueBullets.map(bullet => <motion.li key={bullet.text} variants={{
          hidden: {
            opacity: 0,
            y: 12
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="flex items-center gap-3 rounded-2xl border border-bark-800/[0.08] bg-cream-50 px-4 py-3 text-left text-sm font-medium text-bark-800" data-id="element-110" data-mp="2b0plx132wqgg">
              <span aria-hidden="true" className="text-lg" data-id="element-111" data-mp="2tztrfzvew23d">
                {bullet.emoji}
              </span>
              <span data-id="element-112" data-mp="unrdf55k3zx3">{bullet.text}</span>
            </motion.li>)}
        </motion.ul>

        <div className="mx-auto mt-9 max-w-md rounded-[2rem] bg-bark-900 p-6 shadow-warm-lg sm:p-8" data-id="element-113" data-mp="zkraiqkfhsc2">
          <CTAButton href="#kit-completo" data-id="element-114" data-mp="4akx2ytnmkfz">QUIERO MI KIT AHORA →</CTAButton>

          <p className="mt-5 text-center text-sm font-semibold text-cream-50 sm:text-base" data-id="element-115" data-mp="3vhxg7je3l7yj">
            <span aria-hidden="true" data-id="element-116" data-mp="e9a765fb70lo">💚 </span>+1000 padres{' '}
            <span className="font-normal text-cream-200/60" data-id="element-117" data-mp="e8sd9fg4cygx">ya lo tienen</span>
          </p>

          <p className="mt-3 text-center text-[0.7rem] font-medium leading-relaxed text-cream-200/50 sm:text-xs" data-id="element-118" data-mp="9b0eq2kyye3r">
            🛡️ Garantía 7 días · 🔒 Pago seguro · 💳 Mercado Pago · Tarjeta · Transferencia
          </p>
        </div>
      </div>
    </header>;
}